const ISTANBUL_TIME_ZONE = "Europe/Istanbul"

const datePartsFormatter = new Intl.DateTimeFormat("en-CA", {
  timeZone: ISTANBUL_TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
})

const offsetFormatter = new Intl.DateTimeFormat("en-US", {
  timeZone: ISTANBUL_TIME_ZONE,
  timeZoneName: "longOffset",
})

const parts = (date: Date) => {
  const map = Object.fromEntries(
    datePartsFormatter.formatToParts(date).map((part) => [part.type, part.value])
  )
  return {
    year: Number(map.year),
    month: Number(map.month),
    day: Number(map.day),
  }
}

const offsetMilliseconds = (date: Date) => {
  const zone = offsetFormatter
    .formatToParts(date)
    .find((part) => part.type === "timeZoneName")?.value ?? "GMT+00:00"
  const match = zone.match(/GMT([+-])(\d{2}):(\d{2})/)
  if (!match) return 0
  const sign = match[1] === "+" ? 1 : -1
  return sign * (Number(match[2]) * 60 + Number(match[3])) * 60_000
}

export function getIstanbulCountdown(now: Date) {
  const local = parts(now)
  const nextCalendarDay = new Date(Date.UTC(local.year, local.month - 1, local.day + 1))
  const nextYear = nextCalendarDay.getUTCFullYear()
  const nextMonth = nextCalendarDay.getUTCMonth()
  const nextDay = nextCalendarDay.getUTCDate()
  const localMidnightAsUtc = Date.UTC(nextYear, nextMonth, nextDay, 0, 0, 0)
  const targetProbe = new Date(localMidnightAsUtc)
  const target = localMidnightAsUtc - offsetMilliseconds(targetProbe)
  const remaining = Math.max(0, target - now.getTime())
  const totalSeconds = Math.floor(remaining / 1000)

  return {
    days: Math.floor(totalSeconds / 86_400),
    hours: Math.floor((totalSeconds % 86_400) / 3_600),
    minutes: Math.floor((totalSeconds % 3_600) / 60),
    seconds: totalSeconds % 60,
  }
}
